import React, {
  MouseEvent,
} from 'react';
import clsx from 'clsx';
import IconButton from '@mui/material/IconButton';
import {
  useConfirmDialog,
  useNotify,
} from 'core/hooks';
import DeleteIcon from 'core/icons/delete';
import Tooltip from 'core/components/Tooltip';
import {
  paymentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  useDeleteEOB,
} from 'pages/Dashboard/pages/Billing/hooks';
import {
  EOBSummaryResponseDTO,
} from 'dtos/eOBSummaryResponseDTO';

function DeleteContent() {
  return (
    <span>
      Are you sure you want to delete this EOB?
    </span>
  );
}

export default function EOBActions(data: EOBSummaryResponseDTO) {
  const { tag = 'Manual', eobId = 0 } = data;
  const { confirm, closeConfirm } = useConfirmDialog();
  const { mutateAsync: deleteEOB } = useDeleteEOB();
  const notify = useNotify();

  const handleDelete = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    confirm({
      content: <DeleteContent />,
      onConfirm: async () => {
        await deleteEOB(eobId ?? 0);
        paymentsEventChannel.emit('onPaymentsDataChanged', 'eobs');
        closeConfirm();
        notify({
          message: 'EOB deleted successfully.',
          variant: 'success',
        });
      },
      title: 'Delete EOB',
      confirmText: 'Confirm',
    });
  };

  const isAuto = !/manual/i.test(tag ?? '');

  return (
    <div className="flex w-full">
      <Tooltip title={isAuto ? 'Can\'t delete auto-posted EOB' : 'Delete EOB'}>
        <div
          className={clsx({ 'cursor-not-allowed opacity-30': isAuto })}
        >
          <IconButton
            aria-label="Delete EOB"
            size="small"
            onClick={handleDelete}
            color="error"
            disabled={isAuto}
          >
            <DeleteIcon className="!w-5 !h-5 text-black" />
          </IconButton>
        </div>
      </Tooltip>
    </div>
  );
}
